import { useState } from 'react';
import { useIndexedDB } from 'react-indexed-db';
import { useDispatch } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import useCheckAccess from '../../hooks/useCheckAccess';
import useCheckMobileScreen from '../../hooks/useWidth';
import { addPatientToList, setSelectedPatient } from '../../redux/Patient/PatientAction';

const useAddPatient = (handleAcordin) => {
    const [dialog, setDialog] = useState(false);
    const { add, getAll } = useIndexedDB('patients');
    const dispatch = useDispatch();
    const history = useHistory();
    const isMobile = useCheckMobileScreen();
    const { pathname } = useLocation();
    const clinicId = pathname?.split('/').filter((item) => item)[0];
    const { notEditClinical } = useCheckAccess();

    const path = (patient) =>
        `/${clinicId}/patient/${patient.id}/${notEditClinical ? 'profile' : 'forms/form'}`;

    const redirect = (patient) => {
        history.push(path(patient));
    };

    const goToPatientPage = (patient) => {
        if (isMobile) {
            if (handleAcordin) {
                return handleAcordin();
            } else {
                history.replace(path(patient));
            }
        } else {
            dispatch(setSelectedPatient(patient));
            getAll().then((patients) => {
                const existItem = patients.find((item) => item.id === patient.id);
                if (patients.length < 5) {
                    if (!existItem) {
                        handleAddIndexDb(patient);
                        dispatch(addPatientToList(patient));
                    }
                    redirect(patient);
                } else {
                    if (existItem) {
                        redirect(patient);
                    } else {
                        setDialog(true);
                    }
                }
            });
        }
    };
    const handleAddIndexDb = (patient) => {
        const patientItem = {
            id: patient.id,
            first_name: patient.first_name,
            last_name: patient.last_name,
            gender: patient.gender,
            dob: patient.dob
        };
        add(patientItem).then((key) => {
            patient.id = key;
        });
    };

    return { goToPatientPage, dialog, setDialog };
};

export default useAddPatient;
